import React from 'react';

const PergolasWorkShowcase: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-primary mb-4">See Our Work</h2>
          <p className="text-xl text-gray-600">Real pergola installations across Ontario</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <img 
            src="images/pergolas/Collage.png" 
            alt="Collage of pergola installations showing various styles and settings" 
            className="w-full rounded-xl shadow-lg"
            loading="lazy"
          />
        </div>

        {/* Installation Process */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-primary text-center mb-12">Our Installation Process</h3>
          
          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="bg-accent text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-6 text-xl font-bold">
                1
              </div>
              <h4 className="text-lg font-semibold text-primary mb-3">Site Assessment</h4>
              <p className="text-gray-600">
                We visit your property to assess the space, discuss your needs, and provide expert recommendations.
              </p>
            </div>
            
            <div className="text-center">
              <div className="bg-accent text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-6 text-xl font-bold">
                2
              </div>
              <h4 className="text-lg font-semibold text-primary mb-3">Custom Design</h4>
              <p className="text-gray-600">
                Create a custom pergola design that fits your space, style preferences, and budget.
              </p>
            </div>
            
            <div className="text-center">
              <div className="bg-accent text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-6 text-xl font-bold">
                3
              </div>
              <h4 className="text-lg font-semibold text-primary mb-3">Professional Installation</h4>
              <p className="text-gray-600">
                Our certified team handles permits, installation, electrical work, and complete cleanup.
              </p>
            </div>
            
            <div className="text-center">
              <div className="bg-accent text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-6 text-xl font-bold">
                4
              </div>
              <h4 className="text-lg font-semibold text-primary mb-3">Enjoy Your Space</h4>
              <p className="text-gray-600">
                Relax and enjoy your new outdoor living space with full warranty coverage and support.
              </p>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-accent to-green-700 rounded-xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-4">Ready to Transform Your Outdoor Space?</h3>
            <p className="text-xl text-green-100 mb-6">
              Get your custom pergola quote today
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/pergola-quote"
                className="bg-white text-accent px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors inline-block"
              >
                Get Free Quote
              </a>
              <a 
                href="pergola-comparison.html" 
                className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-accent transition-colors inline-block"
              >
                Compare Models
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PergolasWorkShowcase;
